import "./_cardEmploye.scss";

import {faPhone} from "@fortawesome/free-solid-svg-icons";
import {faEnvelope} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {ReactElement} from "react";

import {carteEmploye} from "@/types/carteEmploye";

function CarteEmploye({employe}: {employe: carteEmploye}): ReactElement {
  return (
    <div className="carteEmploye">
      <div className="carteEmploye-bloc">
        <img
          src={employe.image}
          alt={`photo de ${employe.name}`}
          loading="lazy"
        />
        <div className="carteEmploye-bloc--info">
          <div>
            <h5>{employe.name}</h5>
            <p>{employe.fonction}</p>
          </div>
          <div className="carteEmploye-bloc--coordonnees">
            <a href={`tel:${employe.telephone}`}>
              <FontAwesomeIcon icon={faPhone} />
              <span> {employe.telephone}</span>
            </a>

            <a href={`mailto:${employe.email}`}>
              <FontAwesomeIcon icon={faEnvelope} />
              <span> {employe.email}</span>
            </a>
          </div>
        </div>
      </div>
      <p id="fonction">{employe.service}</p>
    </div>
  );
}

export default CarteEmploye;
